import { createEndpointKeyFromFormKeyAndAnswerId } from '@/helpers/registration-check'
import { endpointRequiresStartDate } from '@/components/registration-check/question-item/_helpers/endpointRequiresStartDate'
import { Answer, DepartmentType, Endpoint, Question, QuestionId, QuestionsFormData } from '@/types/questions'

/**
 * Filters and retrieves answers with endpoint notifications based on form data and question content.
 */
export const getActivityEndpoints = (
    formData: QuestionsFormData,
    formDataSelector: string,
    question: Question,
    departmentTypeByQuestionId: Record<QuestionId, DepartmentType> = {},
): Endpoint[] => {
    const matchingFormData = formData[formDataSelector]

    const answersWithEndpointNotification: Endpoint[] = question.questionContent.answers
        .filter((answer: Answer) => {
            if (!answer.result?.endpointNotification) {
                return false
            }

            if (Array.isArray(matchingFormData)) {
                return matchingFormData.includes(answer.id)
            } else {
                return answer.id === matchingFormData
            }
        })
        .map((answer): Endpoint => {
            const departmentType = departmentTypeByQuestionId[question.id]

            return {
                ...answer,
                endpointKey: createEndpointKeyFromFormKeyAndAnswerId(formDataSelector, answer.id),
                startDate: endpointRequiresStartDate(departmentType) ? null : new Date(),
                departmentType,
            }
        })

    return answersWithEndpointNotification
}
